const translations = {
    customer: 'Customer',
    endTime: 'End Time',
    jobDate: 'Job Date',
    productUsageReportDate: 'Product Usage Report Date',
    startTime: 'Start Time'
};

export default translations;
